import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LayoutPresensi } from './layoutPresensi';
import DataPresensiBulan from '../../componen/presensi/admin/DataPresensiBulan';

export const DataPresensiBulanPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
   <LayoutPresensi>
    <DataPresensiBulan />
   </LayoutPresensi>

  )
}
